import { ResponsiveContainer } from '../InvoicePayModal/InvoicePayModal.styled';
import styled from 'styled-components';

export const PayCycleResponsiveContainer = styled(ResponsiveContainer)`
  padding-bottom: 8px;
`;
